export default __webpack_public_path__ + "static/media/art-slt-poster-2.5bf92602.jpg";